/**
 *  Audio
 *
 *  Created by Legman on 12/09/2016.
 *
 */

"use strict";

/**
 * @constructor
 */
function Audio() {
    /**
     * @type {number}
     */
    this.id = -1;

    /**
     * @type {Howl}
     */
    this.howl = null;
}
module.exports = Audio;
